import { WordingMultiAstrologyMeditationLove } from '@/types';

export const MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_SK: WordingMultiAstrologyMeditationLove = {
  components_header_media_content: 'Astrológia',
  components_header_media_multi_content_2: 'Meditácia',
  components_header_media_multi_content_3: 'Láska',
  components_header_text1: 'Sprievodcovia',
  components_header_text2: 'Blog',
  hero_text: 'Nájdite jasnosť, rovnováhu a prepojenie.',
  hero_button_text: 'Začnite svoju cestu',
  components_ressources_subheader_text: 'Tipy a inšpirácia',
  components_ressources_span_text: 'Spája osobné astrologické poznatky, upokojujúce meditačné praktiky a premyslené vedenie v oblasti lásky na podporu sebapoznania, emocionálnej rovnováhy a hlbšieho prepojenia.',
  components_ressources_card_1_title: 'Tipy na meditáciu',
  components_ressources_card_1_text: 'Stručný návod pre lepšie upokojenie, dýchanie a sústredenie.',
  components_ressources_card_2_title: 'Vedenie lásky',
  components_ressources_card_2_text: 'Jednoduché tipy na vybudovanie silnejšieho vzťahu a emocionálnej rovnováhy.',
  components_ressources_link: 'Objavte viac',
  components_notes_and_google_title_1: 'Nájdite jasnosť',
  components_notes_and_google_title_2: 'Vnútorný pokoj',
  components_notes_and_google_title_3: 'Spojenie srdca',
  media_content_section_multi_1_subheader_text: 'Náš podcast',
  media_content_section_multi_2_subheader_text: 'Naše meditácie',
  media_content_section_multi_3_subheader_text: 'Skutočný rozhovor o kozmickej romantike',
  page_media_content_menu_antistress: 'Antistresový',
  page_media_content_menu_mindfulness: 'Všímavosť',
  page_media_content_menu_energyboost: 'Zvýšenie energie',
  page_media_content_menu_mantra: 'Mantra',
  page_media_content_menu_foundations: 'Nadácie',
  page_media_content_menu_spirituality: 'Spiritualita',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'Psychológia',
  page_media_content_menu_trends: 'Trendy',
  page_media_content_menu_compatibility: 'Kompatibilita',
  page_media_content_menu_love: 'Láska',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Články a postrehy',
  text2_section_button_more: 'Načítať viac',
  components_text1_section_title: 'PRÍRUČKY',
  components_text1_subheader_text: 'Kozmické poznanie pre každodenné zosúladenie',
  components_text1_span_text: 'Zosúlaďte sa s rytmami vesmíru: preskúmajte kurátorsky vybranú kolekciu hĺbkových astrologických a meditačných sprievodcov navrhnutých tak, aby prebudili vnútornú jasnosť, prehĺbili sebauvedomenie a podporili vašu cestu duchovného, ​​nebeského rastu.',
  components_text1_card_1_title: 'Otvorené tichu',
  components_text1_card_1_text: 'Začnite svoju cestu so základnými meditačnými a astrologickými sprievodcami – ideálnymi pre hľadajúcich vnútorný pokoj, kozmické vzorce a osobný vhľad.',
  components_text1_card_3_title: 'Prepojenie mysle a tela',
  components_text1_card_3_text: 'Odhaľte hlbšie vrstvy svojho vnútorného sveta. Títo sprievodcovia sa posúvajú pod povrch, aby odhalili význam, emócie a vzorce vedomia, ktoré formujú vašu skúsenosť.',
  components_text1_card_2_title: 'Reflektovať a integrovať',
  components_text1_card_2_text: 'Od emocionálnych blokov až po planetárne cykly – títo sprievodcovia ponúkajú nástroje na reflexiu, liečenie a transformáciu prostredníctvom všímavých rituálov a astrologickej múdrosti.',
  components_text1_link: 'Zobraziť všetkých sprievodcov',
  components_footer_text: 'Nájdite jasnosť, vyrovnajte svoju myseľ a spojte sa so zmyslom – vaše miesto pre astrológiu, meditáciu a lásku.',
};